import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IconComponent } from '@mode/capra';

@Component({
  selector: 'mode-data-retention-no-data',
  standalone: true,
  imports: [CommonModule, IconComponent],
  templateUrl: './data-retention-no-data.component.html',
  styleUrls: ['./data-retention-no-data.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DataRetentionNoDataComponent {
  @Input() icon!: string | undefined;
  @Input() header!: string;
  @Input() subtext!: string;
}
